import React, { Fragment, useEffect } from 'react';

import TopPage from 'v2/components/Shared/TopPage';
import ordersService from 'v2/services/orders';

import { Details } from './Details';
import Filter from './Filter';
import LabelGenerator from './LabelGenerator';
import List from './List';
import { ModalRefund } from './ModalRefund';
import ModalTrackingCodes from './ModalTrackingCodes';
import Quickview from './Quickview';

const Orders = () => {
  useEffect(() => {
    return () => ordersService.cleanFilter();
  }, []);

  return (
    <Fragment>
      <TopPage title='Minhas Entregas' extra='Gerencie sua entregas de produtos físicos' disableAlerts />
      <Filter />
      <Details />
      <LabelGenerator />
      <List />
      <Quickview />
      <ModalRefund />
      <ModalTrackingCodes />
    </Fragment>
  );
};

export default Orders;
